<template>
    <el-table :data="data" :default-sort="{ prop: 'searchTimestamp', order: 'descending' }" empty-text="No user searches to display" class="w-100">
        <el-table-column label="User Id" prop="id"> </el-table-column>
        <el-table-column label="Email" prop="email"> </el-table-column>
        <el-table-column label="Phone Number" prop="phoneNumber"> </el-table-column>
        <el-table-column align="right">
            <template slot-scope="scope">
                <router-link :to="{ path: `/portal/users/${scope.row.id}` }" class="btn btn-sm btn-primary">
                    Open
                </router-link>
            </template>
        </el-table-column>
    </el-table>
</template>
<script>
import { USERS } from 'db'
export default {
    props: {
        data: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            USERS
        }
    }
}
</script>

<style lang="scss" scoped>
.el-table table .btn {
    margin: 0 5px;
}
</style>
